import { motion, useAnimate } from 'framer-motion';
import React from 'react';
interface BadgeProps {
  body: number;
}
export default function Badge({
  body
}: BadgeProps) {
  const [scope, animate] = useAnimate();
  React.useEffect(() => {
    animate(scope.current, {
      scale: [1.1, 1]
    });
  }, [body, animate, scope]);
  return <motion.span ref={scope} className="inline-flex items-center justify-center rounded-full bg-primary h-5 w-5 text-xs font-bold text-white" data-sentry-element="unknown" data-sentry-component="Badge" data-sentry-source-file="badge.tsx">
      {body}
    </motion.span>;
}